import React from "react";

export function About() {
  return (
      <p>
        <a href="https://en.wikipedia.org/wiki/Conway%27s_Game_of_Life">Conway's Game Of Life</a> is a cellular automaton simulating cellular life. That's why it's often used as an example for automatons, as there are only four rules required to implement the automaton.
      </p>
  );
}
